// extracted by mini-css-extract-plugin
module.exports = {"bg_services":"Services_bg_services___310S","btn_more":"Services_btn_more__rRuh2"};